<template>
  <audit-list :audits="audits" title="Assigned Audits / Verifications" subtitle=" " :busy="isBusy" @updateAudits="getAudits" />
</template>

<script>
import AuditList from './AuditList.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'AssignedAudits',

  components: { AuditList },
  data () {
    return {
      audits: [],
      isBusy: true
    }
  },
  computed: {
    ...mapGetters(['activeGroup'])
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      await this.getAudits()
    },
    async getAudits () {
      if (this.activeGroup !== 'null') {
        try {
          this.isBusy = true
          let reply = await this.$api.get('/audits/by_auditing_org')
          this.audits = reply.data
          if (this.audits.length === 0) {
            reply = await this.$api.get('/audits/by_auditor')
            this.audits = reply.data
          }
        } catch (e) {
          this.$showError(e);
        } finally {
          this.isBusy = false
        }
      }
    }
  }
}
</script>
